export default "__VITE_ASSET__f294ffe6__"